export const queryKeys = {
  documents: () => ['documents'] as const,
  domains: () => ['domains'] as const,
  document: (docId: string) => ['document', docId] as const,
  pnidImage: (docId: string, level: number) => ['pnid-image', docId, level] as const,
  // The prefix of the admin and the per-user annotation lists, so one write refreshes both.
  allAnnotations: () => ['annotations'] as const,
  annotations: (isAdmin: boolean) => [...queryKeys.allAnnotations(), { isAdmin }] as const,
  pnidState: (docId: string) => ['pnid-state', docId] as const,
  // One instrument as its own route serves it, fresher than the drawing state's copy.
  pnidInstrument: (docId: string, instrumentId: string) => ['pnid-instrument', docId, instrumentId] as const,
  // The working copy's updated_at sits in the key, so each save that reaches the
  // drawing state reads the endpoint afresh. The drawing prefix covers a write that
  // leaves updated_at as it was.
  publishableAssetsOfDrawing: (docId: string) => ['publishable-assets', docId] as const,
  publishableAssets: (docId: string, workingCopyUpdatedAt: string) =>
    ['publishable-assets', docId, workingCopyUpdatedAt] as const,
  equipmentTypes: () => ['equipment-types'] as const,
  formSchemas: () => ['form-schemas'] as const,
  registerContext: (docId: string) => ['register-context', docId] as const,
  clickTargets: (docId: string) => ['click-targets', docId] as const,
  plants: () => ['plants'] as const,
  plantHierarchy: (domainId: string) => ['plants', domainId, 'hierarchy'] as const,
  plantPublishPlan: (domainId: string) => ['plants', domainId, 'publish-plan'] as const,
  // The plant prefix, so one invalidation after a write covers the plant page
  // and every per-drawing read of the queue.
  agentReviewQueues: (domainId: string) => ['plants', domainId, 'agent-review-queue'] as const,
  agentReviewQueue: (domainId: string, docId?: string | null) =>
    [...queryKeys.agentReviewQueues(domainId), docId ?? 'all'] as const,
  plantAssetMatch: (domainId: string, tag: string) => ['plant-asset-match', domainId, tag] as const,
  assetDocuments: (assetId: string) => ['asset-documents', assetId] as const,
  redundancySets: {
    all: () => ['redundancy-sets'] as const,
    list: (domainId: string) => ['redundancy-sets', domainId] as const,
  },
  legendSheets: {
    all: () => ['legend-sheets'] as const,
    list: (domainId: string) => ['legend-sheets', domainId] as const,
  },
  tagSuggestions: (docId: string, kind: string, query: string) =>
    ['tag-suggestions', docId, kind, query] as const,
  lineSuggestions: (docId: string, query: string) => ['line-suggestions', docId, query] as const,
  aiData: (docId: string) => ['ai-data', docId] as const,
  comments: (docId: string) => ['comments', docId] as const,
  workspaceConfig: () => ['workspace-config'] as const,
};
